module.exports = __webpack_public_path__ + "img/arbiter.96076241.svg";